<template>
    <v-dialog :value="value" max-width="600px" persistent scrollable>
        <v-card class="kbLight">
            <v-toolbar color="kbLightBlue" dark flat>
                <v-toolbar-title>
                    {{ journeyId ? $t('general.editJourney') : $t('general.addNewJourney') }}
                </v-toolbar-title>

                <v-spacer />

                <v-btn icon @click="toggleModal()">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <template v-if="!loadingJourney">
                    <v-form ref="journeyForm">
                        <v-row>
                            <v-col cols="12">
                                <v-text-field :label="$t('general.name')"
                                              color="kbDarkBlue"
                                              :rules="[rules.required]"
                                              v-model="journeyForm.name"/>
                            </v-col>
                            <v-col cols="12">
                                <v-select :items="possibleAssociatedJourneyIds"
                                          color="kbDarkBlue"
                                          hide-details
                                          :label="$t('general.dependencies')"
                                          item-value="id"
                                          item-text="name"
                                          item-color="kbDarkBlue"
                                          multiple
                                          v-model="journeyForm.dependsOn"/>
                            </v-col>
                            <v-col cols="12">
                                <h5 class="mb-4 kbDarkBlue--text">{{$t('general.selectJourneyColor')}}</h5>
                                <!--<v-color-picker v-model="journeyForm.mainColor"></v-color-picker>-->
                                <v-select :items="cardsColors"
                                          color="kbDarkBlue"
                                          :label="$t('general.chooseAColor')"
                                          item-value="value"
                                          item-text="name"
                                          item-color="kbDarkBlue"
                                          :rules="[rules.required]"
                                          v-model="journeyForm.mainColor">
                                    <template v-slot:item="{ item }">
                                        <v-icon :color="item.value" class="mr-2">mdi-circle</v-icon>
                                        <span>{{ item.name }}</span>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-divider/>
                            </v-col>
                            <v-col cols="12">
                            <span class="kbDarkBlue--text" style="font-size: 16px">
                                {{$t('general.wantThisDefaultStateWhenSomeoneSignsUp')}}
                            </span>
                                <v-switch v-model="journeyForm.setOnRegister"
                                          color="kbDarkBlue"
                                          :label="journeyForm.setOnRegister ? $t('general.yes'):$t('general.no')"/>
                            </v-col>
                            <v-col cols="12">
                            <span class="kbDarkBlue--text" style="font-size: 16px">
                                {{$t('general.wantToShowThisStateOnTheSideMenu')}}
                            </span>
                                <v-switch v-model="journeyForm.createMenu"
                                          color="kbDarkBlue"
                                          :label="journeyForm.createMenu ? $t('general.yes'):$t('general.no')"/>
                            </v-col>
                        </v-row>
                    </v-form>
                </template>
                <template v-else>
                    <p class="text-center kbDarkBlue--text">{{$t('general.loadingJourney')}}</p>
                </template>
            </v-card-text>
            <v-card-actions class="pb-3 pr-3">
                <v-spacer/>
                <v-btn color="red"
                       class="mr-1"
                       outlined
                       @click="toggleModal()">{{$t('general.cancel')}}</v-btn>
                <v-btn color="kbLightBlue"
                       dark
                       :loading="loadingNewEditJourney"
                       @click="submit()">{{ journeyId ? $t('general.editJourney') : $t('general.addJourney') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
import { mapGetters, mapState } from 'vuex'
export default {
  computed: {
    ...mapGetters(['journeysIds']),
    ...mapState({
      pagination: state => state.journey.pagination,
      selectedJourney: state => state.journey.selectedJourney
    }),
    possibleAssociatedJourneyIds () {
      if (!this.journeyId || this.journeysIds.length === 0) return this.journeysIds
      const modifiedIds = [...this.journeysIds]
      const indexOfCurrentJourney = [...modifiedIds].map(item => item.id).indexOf(this.journeyId)
      modifiedIds.splice(indexOfCurrentJourney, 1)
      return modifiedIds
    },
    cardsColors () {
      return [
        { name: this.$t('general.yellow'), value: 'rgb(255, 255, 0)' },
        { name: this.$t('general.orange'), value: 'rgb(255, 128, 0)' },
        { name: this.$t('general.red'), value: 'rgb(255, 0, 0)' },
        { name: this.$t('general.purple'), value: 'rgb(87, 35, 100)' },
        { name: this.$t('general.darkBlue'), value: '#4279D6' },
        { name: this.$t('general.lightBlue'), value: '#11CDEF' },
        { name: this.$t('general.green'), value: '#2DCE98' },
        { name: 'Magenta', value: '#F66277' }
      ]
    }
  },
  data () {
    return {
      loadingJourney: false,
      loadingNewEditJourney: false,
      journeyForm: {
        name: '',
        dependsOn: [],
        createMenu: false,
        setOnRegister: false,
        mainColor: '',
        template: {
          x: -700,
          y: -69,
          description: ''
        }
      },
      notifications,
      rules
    }
  },
  methods: {
    async addNewJourney () {
      try {
        let { mainColor, ...all } = this.journeyForm
        if (!mainColor) {
          mainColor = '#4279D6'
        }
        await this.$store.dispatch('newJourney', { data: { mainColor, ...all }, companyId: this.$route.params.companyid, appId: this.$route.params.appid })
        await this.$store.dispatch('getJourneys', { pagination: this.pagination, companyId: this.$route.params.companyid, appId: this.$route.params.appid })
        this.loadingNewEditJourney = false
        notifications.success(this.$t('general.journeySuccessfullyCreated'))
        this.toggleModal()
      } catch (e) {
        this.loadingNewEditJourney = false
        notifications.error(e)
        throw e
      }
    },
    resetJourneyForm () {
      this.journeyForm.name = ''
      this.journeyForm.dependsOn = []
      this.journeyForm.createMenu = false
      this.journeyForm.setOnRegister = false
      this.journeyForm.mainColor = ''
      this.journeyForm.template.description = ''
    },
    async setJourneyForm () {
      this.loadingJourney = true
      try {
        await this.$store.dispatch('getJourney', { companyId: this.$route.params.companyid, appId: this.$route.params.appid, journeyId: this.journeyId })
        this.journeyForm = {
          name: this.selectedJourney.name,
          dependsOn: this.selectedJourney.dependsOn.map(item => item.id),
          createMenu: this.selectedJourney.createMenu,
          setOnRegister: this.selectedJourney.setOnRegister,
          mainColor: this.selectedJourney.mainColor,
          template: { ...this.selectedJourney.template }
        }
        this.loadingJourney = false
      } catch (e) {
        this.loadingJourney = false
        throw e
      }
    },
    submit () {
      if (!this.$refs.journeyForm.validate()) return
      this.loadingNewEditJourney = true
      this.journeyId ? this.updateJourney() : this.addNewJourney()
    },
    toggleModal () {
      this.$emit('input', false)
    },
    async updateJourney () {
      try {
        const data = { ...this.journeyForm, replaceVal: true }
        await this.$store.dispatch('updateJourney', { journeyId: this.journeyId, data })
        await this.$store.dispatch('getJourneys', { pagination: this.pagination, companyId: this.$route.params.companyid, appId: this.$route.params.appid })
        this.loadingNewEditJourney = false
        notifications.success(this.$t('general.journeySuccessfullyEdited'))
        this.toggleModal()
      } catch (e) {
        this.loadingNewEditJourney = false
        notifications.error(e)
        throw e
      }
    }
  },
  props: {
    journeyId: {
      type: [String, Number]
    },
    value: {
      type: Boolean
    }
  },
  watch: {
    value (newValue) {
      if (!newValue) {
        this.resetJourneyForm()
        this.$store.commit('SET_SELECTED_JOURNEY', {})
      } else if (newValue && this.journeyId) {
        this.setJourneyForm()
      }
    }
  }
}
</script>
